<input [(ngModel)]="value" [ngClass]="{ invalid: invalid | async }" [id]="inputIdentifier" type="hidden" />
<label class="route-selector__input-label form-label form-label--action" *ngIf="label" [attr.for]="inputIdentifier">
    {{ label }}
</label>
<div
    class="autocomplete dropdown"
    [ngClass]="{ 'autocomplete--open': isOpen }"
    aria-expanded="false"
    attr.aria-controls="{{ identifier }}"
    role="combobox">
    <ridango-form-field>
        <input
            class="autocomplete__input"
            id="{{ identifier }}"
            [(ngModel)]="filter"
            [ngClass]="{ 'text-input--error': showErrors }"
            [required]="required"
            [attr.aria-expanded]="isOpen"
            [attr.aria-owns]="listBoxId"
            [attr.aria-controls]="listBoxId"
            [attr.aria-labelledby]="labelId"
            (ngModelChange)="filterChanged()"
            (keydown)="keyDown($event)"
            (focus)="onFocus()"
            role="combobox"
            ridangoInput
            autocomplete="off"
            aria-haspopup="listbox"
            aria-autocomplete="list" />
        <img class="hide-for-wcag" src="assets/icon_arrowdown.svg" alt="" />
        <img class="show-high-contrast-view" src="assets/icon_arrowdown-wcag.svg" alt="" />
        <div class="dropdown__vertical-line"></div>
        <ridango-label id="{{ labelId }}">{{ placeholder | translate }}</ridango-label>

        <!-- <ridango-icon-button *ngIf="filter" [rclass]="'autocomplete__inline-button'" [icon]="'icon icon-input-delete'"
            (onClick)="clearFilter()">
        </ridango-icon-button> -->
    </ridango-form-field>

    <ridango-selectable-list
        [items]="filteredArray"
        [selectedItem]="selectedItem"
        [selectedIndex]="selectedIndex"
        [rclass]="'autocomplete__choices expanded'"
        [listBoxId]="listBoxId"
        [listItemIdPrefix]="listItemIdPrefix"
        [labelledBy]="labelId"
        (onItemSelected)="itemSelectedFromList($event)"></ridango-selectable-list>
</div>
